// extracted by mini-css-extract-plugin
export default {"chat":"projectChat_chat__K8D7p"};